import styled from 'styled-components'
import { BREAK_POINT_LG } from '@CSSVars/variables'
import AppButton from 'Components/AppButton'

import { GREY_BACKGROUND, PRIMARY_DARK_COLOR } from '@CSSVars/colors'

export const _Title = styled.div`
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  text-align: center;
  color: ${PRIMARY_DARK_COLOR};
`

export const _PreApprovedContainer = styled.div`
  width: ${({ mobileContainer }) => (mobileContainer ? '100%' : '248px')};
  height: ${({ mobileContainer }) => (mobileContainer ? '100%' : 'fit-content')};
  border-radius: 10px;
  background: ${GREY_BACKGROUND};
  padding: 24px;
  display: ${({ mobileContainer }) => (mobileContainer ? 'none' : 'flex')};
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    margin: 24px 0 32px;
    display: ${({ mobileContainer, rentalListing }) => (!mobileContainer && !rentalListing ? 'none' : 'flex')};
    width: 100%;
  }
`

export const _PreApprovedCTA = styled(AppButton)`
  height: 36px;
  width: 100%;
`

export const _SpeakToExpertCTA = styled(AppButton)`
  border: 1px solid ${PRIMARY_DARK_COLOR};
  height: 36px;
  width: 100%;
  background: transparent;
  color: ${PRIMARY_DARK_COLOR};
  &:hover {
    background: white;
    color: ${PRIMARY_DARK_COLOR};
  }
`

export const _MyAbodeMortgage = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  span {
    font-family: Montserrat;
    font-size: 12px;
    font-weight: 500;
    line-height: 22px;
  }
  img {
    width: 83px;
    height: auto;
  }
`
